import * as THREE from 'three';
import horizonHazeShader from '../shaders/horizonHaze.js';

export function createHorizonHazeMaterial(options = {}) {
    const {
        baseColor = new THREE.Color(0x000000),
        envMap = envMap,
        hazeStart = 100,        // distance where haze starts
        hazeEnd = 500,          // distance where haze is fully applied
        horizonHeight = 0.05,   // Y offset for horizon sampling (0 = true horizon)
        hazeIntensity = 1.0     // overall haze strength (0-1)
    } = options;

    const material = new THREE.ShaderMaterial({
        uniforms: {
            uBaseColor: { value: baseColor },
            uEnvMap: { value: envMap },
            uCameraPosition: { value: new THREE.Vector3() },
            uHazeStart: { value: hazeStart },
            uHazeEnd: { value: hazeEnd },
            uHorizonHeight: { value: horizonHeight },
            uHazeIntensity: { value: hazeIntensity }
        },
        vertexShader: horizonHazeShader.vert,
        fragmentShader: horizonHazeShader.frag,
        side: THREE.FrontSide
    });

    return material;
}
